import React from 'react';
import { Flex } from '@rebass/grid';
import { Button, EmailSearch, LoaderWrapper } from '../../components';
import { SearchBox } from './ForwardAFriendContainer.styles';
import { useState } from 'react';
import { LoginLogo } from '../LoginContainer/LoginContainer.styles';
import useQuery from '../../customHooks/useQuery';
import axios from 'axios';
import { apiDetails, objectToFormData } from '../../services/helpers';
import { encryptPassword } from '../../utils';
import { isEmpty } from 'lodash';
import ThankYou from './ForwardAFriendConfirmation';

const ForwardAFriendContainer = () => {
  const [loading, setLoading] = useState(false);
  const [openConfirmationPage, setOpenConfirmationPage] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const [emailIds, setEmailIds] = useState('');
  const query = useQuery();
  const fromEmail = query.get('from_email');
  const newsletterId = query.get('newsletter_id');
  const uid = query.get('uid');

  const handleEmailInput = (value) => {
    setEmailIds(value);
  };

  // const handleSendClick = () => {
  //   setOpenConfirmationPage(true);
  // };

  const handleValidation = () => {
    const isEmailRegEx =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;

    if (isEmpty(emailIds)) {
      setErrorMsg('Please enter email address');
      return true;
    } else if (!isEmpty(emailIds)) {
      let checkEmail = emailIds
        .split(',')
        .map((em) => em.trim())
        .every((em) => isEmailRegEx.test(em.toLowerCase()));
      if (emailIds.split(',').length > 5 && checkEmail) {
        setErrorMsg('Maximum 5 emails can be added');
        return true;
      } else if (checkEmail && emailIds.split(',').length <= 5) {
        return false;
      } else if (!checkEmail) {
        setErrorMsg('Email Ids are not correct');
        return true;
      }
    } else {
      return false;
    }
  };

  const handleSubmit = () => {
    console.log('clicked');
    let valid = handleValidation();
    if (!valid) {
      setLoading(true);
      let payload = {
        newsletter_id: newsletterId,
        emails: emailIds.split(','),
        uid,
        from_email: fromEmail,
      };

      payload = JSON.stringify(payload);
      payload = encodeURIComponent(encryptPassword(payload));

      axios
        .post(
          `${apiDetails.baseUrl}callback?clout_feature=forward_email`,
          objectToFormData({
            clout_feature: 'forward_email',
            payload,
          }),
          {
            headers: {
              'Content-type': 'multipart/form-data',
            },
          }
        )
        .then((res) => {
          console.log('res-', res);
          setLoading(false);
          setErrorMsg('');
          setOpenConfirmationPage(true);
        })
        .catch((err) => {
          setLoading(false);
          setOpenConfirmationPage(false);
          console.log(err);
        });
    }
  };
  return (
    <Flex
      display="flex"
      justifyContent="center"
      flexDirection="column"
      width="100%"
    >
      <Flex width="100%" justifyContent="center">
        <LoginLogo
          style={{ width: '200px', textAlign: 'left', marginLeft: '-28px' }}
          src="/assets/images/TIFIN-Clout-Logo-Color.png"
          alt="mio-logo"
        />
      </Flex>

      <hr
        style={{
          margin: '0',
          padding: '0',
          width: '100%',
          border: '1px solid #E4E7EC',
        }}
      />
      {!openConfirmationPage && (
        <Flex
          display="flex"
          flexDirection="column"
          margin="100px auto 15px auto"
          width={window.innerWidth < 600 ? '100%' : '50%'}
        >
          <Flex
            display="flex"
            padding="3px"
            fontSize="20px"
            fontWeight={600}
            style={{ lineHeight: '25px' }}
            color="#101828"
            justifyContent="center"
          >
            Share article with your network
          </Flex>
          {/* <Flex
            style={{
              fontSize: '12px',
              color: '#475467',
              width: "51%",
              margin: '0px auto'
            }}
          >
            Placeholder Subtext
          </Flex> */}
          <Flex
            mb="10px"
            width="100%"
            pl={window.innerWidth < 600 ? '13%' : '24%'}
            display="flex"
            flexDirection="column"
          >
            <Flex
              style={{
                fontSize: '14px',
                color: '#101828',
                textAlign: 'left',
                padding: '27px 0px 1px 2px',
              }}
            >
              Add Email Address
            </Flex>
            <SearchBox
              placeholder="Type in email address(es), separated by commas"
              type="text"
              id="search-box"
              name="email_search"
              value={emailIds}
              onChange={(e) => handleEmailInput(e.target.value)}
            />
          </Flex>
          <Flex
            margin="auto"
            width={window.innerWidth < 600 ? '87%' : '89%'}
            display="flex"
            justifyContent="center"
            pl={window.innerWidth < 600 ? '0px' : '77px'}
          >
            <LoaderWrapper isLoading={loading}>
              <Button
                styles={{ borderRadius: '4px', width: '85%' }}
                type="button"
                margin="10px 0px"
                onClick={handleSubmit}
              >
                Send
              </Button>
            </LoaderWrapper>
          </Flex>
          {errorMsg && (
            <Flex
              display="flex"
              justifyContent="center"
              width="100%"
              pl={window.innerWidth < 600 ? '0' : '16%'}
              margin={window.innerWidth < 600 ? 'auto' : '0px auto'}
            >
              {errorMsg}
            </Flex>
          )}
        </Flex>
      )}

      {openConfirmationPage && <ThankYou emailIds={emailIds} />}
    </Flex>
  );
};

export default ForwardAFriendContainer;
